// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { KeyValueSchema } from './KeyValueSchema'
import type { KeyValue } from './KeyValueSchema'
import { CookieSchema } from './CookieSchema'
import type { Cookie } from './CookieSchema'
import { HttpResponseSchema } from './HttpResponseSchema';

/////////////////////////////////////////
// HTTP RESPONSE RELATION SCHEMA
/////////////////////////////////////////

export type HttpResponseRelations = {
  headers: KeyValue[];
  cookies: Cookie[];
};

export type HttpResponseWithRelations = z.infer<typeof HttpResponseSchema> & HttpResponseRelations

export const HttpResponseWithRelationsSchema: z.ZodType<HttpResponseWithRelations> = HttpResponseSchema.merge(z.object({
  headers: z.lazy(() => KeyValueSchema).array(),
  cookies: z.lazy(() => CookieSchema).array(),
}))